export enum ActionInstanceColumnType {
    SingleOption = "SingleOption",
    MultiOption = "MultiOption",
    Text = "Text",
    Numeric = "Numeric",
    Location = "Location",
    DateTime = "DateTime",
    AttachmentList = "AttachmentList",
    PhoneNumber = "PhoneNumber",
    Date = "Date",
    LargeText = "LargeText",
    UserId = "UserId"
}